var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_612_60775",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 11.667C7.71634 11.667 8.83301 10.5503 8.83301 9.16699C8.83301 7.78366 7.71634 6.66699 6.33301 6.66699C4.94967 6.66699 3.83301 7.78366 3.83301 9.16699C3.83301 10.5503 4.94967 11.667 6.33301 11.667ZM6.33301 8.33366C6.79134 8.33366 7.16634 8.70866 7.16634 9.16699C7.16634 9.62533 6.79134 10.0003 6.33301 10.0003C5.87467 10.0003 5.49967 9.62533 5.49967 9.16699C5.49967 8.70866 5.87467 8.33366 6.33301 8.33366ZM16.333 5.83366H9.66634V12.5003H2.99967V4.16699H1.33301V16.667H2.99967V14.167H17.9997V16.667H19.6663V9.16699C19.6663 7.32533 18.1747 5.83366 16.333 5.83366ZM17.9997 12.5003H11.333V7.50033H16.333C17.2497 7.50033 17.9997 8.25033 17.9997 9.16699V12.5003Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 11.667C7.71634 11.667 8.83301 10.5503 8.83301 9.16699C8.83301 7.78366 7.71634 6.66699 6.33301 6.66699C4.94967 6.66699 3.83301 7.78366 3.83301 9.16699C3.83301 10.5503 4.94967 11.667 6.33301 11.667ZM6.33301 8.33366C6.79134 8.33366 7.16634 8.70866 7.16634 9.16699C7.16634 9.62533 6.79134 10.0003 6.33301 10.0003C5.87467 10.0003 5.49967 9.62533 5.49967 9.16699C5.49967 8.70866 5.87467 8.33366 6.33301 8.33366ZM16.333 5.83366H9.66634V12.5003H2.99967V4.16699H1.33301V16.667H2.99967V14.167H17.9997V16.667H19.6663V9.16699C19.6663 7.32533 18.1747 5.83366 16.333 5.83366ZM17.9997 12.5003H11.333V7.50033H16.333C17.2497 7.50033 17.9997 8.25033 17.9997 9.16699V12.5003Z",
    fill: "black",
    stroke: "#667085",
    strokeWidth: 3.33333,
    mask: "url(#path-1-inside-1_612_60775)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.40efcc7078ca78d9f571f1f3038a06a1.svg";
export { ForwardRef as ReactComponent };